<template>
  <div class="send-email-dialog" v-if="innerShow">
    <div class="mask" @click="innerShow = false"></div>
    <div class="dialog-body">
      <div class="dialog-header">发送至邮箱</div>
      <div class="dialog-content">
        <div class="email-input-box">
          <input
            type="text"
            class="email-input"
            placeholder="请输入接收邮箱"
            v-model.trim="email"
            :show-clear="false"
            :max="50"
          />
        </div>
        <div class="send-btn-box">
          <button
            class="send-btn"
            @click="sendEmail"
            :disabled="!email || loading"
          >
            <div class="text-box">发送至邮箱</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../services/tools.js';
import toast from '../services/toast.js';
import http from '../services/http';

const MAIL_REG = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;

export default {
  name: '',
  components: {},
  props: {
    show: {
      type: Boolean,
    },
    user_order_id: {
      type: Number,
    },
    order_applicant_id: {
      type: Number,
    },
  },
  data() {
    return {
      email: '',
      loading: false,
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },
  watch: {
    innerShow(value) {
      if (value) {
        this.email = this.defaultEmail;
      }
    },
  },
  created() {},
  methods: {
    sendEmail() {
      if (!this.user_order_id || !this.order_applicant_id) return;

      if (!this.email) {
        return toast.show('请输入邮箱地址');
      }

      if (!MAIL_REG.test(this.email)) {
        return toast.show('请输入正确的邮箱地址');
      }
      // 显示
      this.loading = true;
      http
        .post('h5/applicant_interview_email_send', {
          user_order_id: this.user_order_id,
          order_applicant_id: this.order_applicant_id,
          email: this.email,
          is_app: 1,
        })
        .then(() => {
          this.innerShow = false;
          toast.show('发送成功');
        })
        .catch((error) => {
          toast.show(error.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
.send-email-dialog {
  .mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .dialog-body {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1001;
    transform: translate(-50%, -50%);
    width: 3rem;
    max-width: 90%;
    overflow: hidden;
    background: #fff;
    border-radius: 0.08rem;
  }

  .dialog-header {
    height: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-weight: bold;
    border: 0.01rem solid #e0e0e0;
  }
  .dialog-content {
    padding: 0.16rem 0.16rem;
    .email-input {
      box-sizing: border-box;
      width: 100%;
      height: 0.45rem;
      padding: 0 0.11rem;
      border-radius: 0.04rem;
      -webkit-appearance: none;
      outline: none;
      font-size: 0.14rem;
      color: #333;
      border: 1px solid #999;
      line-height: 0.45rem;
      padding-left: 0.1rem;
      margin-bottom: 0.16rem;
      border-radius: 0.08rem;
      border: 0.01rem solid #c0c0c0;
    }
    .send-btn-box {
      margin-top: 0.1rem;
      .send-btn {
        width: 100%;
        border: none;
        outline: none;
        background: linear-gradient(
          153deg,
          rgba(255, 96, 82, 1) 0%,
          rgba(255, 75, 77, 1) 100%
        );
        border-radius: 0.2rem;
        height: 0.4rem;
        font-size: 0.16rem;
        color: #fff;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        &:disabled {
          background: #ddd;
        }
      }
    }
  }
}
</style>
